import { Button, Icon, IconButton } from '@smartgift/frontend-toolkit';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { configs } from '@hero/configs';
import { PageLayout } from '@hero/layouts';
import { ChooseFeatureTypeModal } from '@hero/organisms';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetUser } from '@hero/services/organization-service/hooks';
import { useShoppingCart } from '@hero/store/hooks';
import { HomeTemplateComponent } from '@hero/templates';

const ShoppingButton = styled(IconButton)`
  border-color: var(--color-border-default);
  height: 48px;
  width: 48px;
`;

const ShoppingButtonBadge = styled.span`
  align-items: center;
  background: var(--color-components-button-primary-outlined-fg);
  border-radius: var(--size-border-radius-circle);
  color: var(--color-components-button-primary-outlined-bg);
  display: flex;
  font-size: 14px;
  font-weight: 700;
  height: 24px;
  justify-content: center;
  line-height: 150%;
  position: absolute;
  right: -10px;
  text-align: center;
  top: -10px;
  width: 24px;
`;

export default function Page({ pageData }) {
  const { t } = useTranslation();
  const { data: user } = useGetUser();
  const [isSendGiftModalOpen, setIsSendGiftModalOpen] = useState(false);
  const { products, setOpened } = useShoppingCart();
  const navigate = useNavigate();

  function handleSendGiftsButton() {
    if (configs?.general?.simplifyFlow && !user?.meta?.isPunchoutUser) {
      navigate(ROUTE_PATHS.SEND_GIFT_OCCASIONS);
    } else {
      setIsSendGiftModalOpen(true);
    }
  }

  return (
    <PageLayout
      header={{
        title: t('hiUser', { firstName: user?.firstName }),
        components: {
          EndContent: () => (
            <>
              <Button color="primary" onClick={handleSendGiftsButton}>
                {t('sendGiftsNow')}
              </Button>
              <ShoppingButton
                name="shopping-cart"
                size="lg"
                variant="outlined"
                rounded={true}
                onClick={() => setOpened(true)}
                style={{ position: 'relative' }}
              >
                <ShoppingButtonBadge>{products.length}</ShoppingButtonBadge>
                <Icon name="shopping-cart" size="lg" />
              </ShoppingButton>
              <ChooseFeatureTypeModal
                isOpen={isSendGiftModalOpen}
                onClose={() => {
                  setIsSendGiftModalOpen(false);
                }}
              />
            </>
          )
        }
      }}
      pageData={pageData}
    >
      <HomeTemplateComponent />
    </PageLayout>
  );
}
